(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';

  const data = window.SLDEstimatorData;
  const { FABRICS, LENGTHS, WIDTHS, VENTED, POCKET } = data.products.catchAll;
  const controls = data.productControls.catchAll;

  const FIELD_LABELS = Object.freeze({
    'Fabric/Color * (required)': 'Fabric',
    'Hammock Length * (required)': 'Length',
    'Width * (required)': 'Width',
    'Vented (Sil Versions only) * (required)': 'Vented',
    'Zippered Strap Pocket * (required)': 'Pocket'
  });

  const DEFAULTS = Object.freeze({ Vented: 'No', Pocket: 'No' });
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const exactText = (value) => String(value || '').trim();

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(FIELD_LABELS, label)) continue;
      selected[FIELD_LABELS[label]] = exactText(element.value);
    }
    return selected;
  }

  function preference(choice, field) {
    const value = choice[field];
    return value === undefined || value === '' ? DEFAULTS[field] : value;
  }

  function estimate(choice) {
    const fabric = FABRICS[choice.Fabric];
    const rawLength = LENGTHS[choice.Length];
    const widthClass = WIDTHS[choice.Width];
    if (!fabric || !rawLength || !widthClass) return null;

    const ventChoice = preference(choice, 'Vented');
    const pocketChoice = preference(choice, 'Pocket');
    if (!own(VENTED, ventChoice) || !own(POCKET, pocketChoice)) return null;

    const vented = VENTED[ventChoice];
    if (!fabric.waterproof && vented) {
      return {
        incompatible: true,
        message: 'Venting is only available with Sil fabrics. Select “No” for venting or choose a Sil fabric.'
      };
    }

    const rawWidth = widthClass === 'wide'
      ? controls.rawWidthInches.wide
      : (fabric.waterproof
        ? controls.rawWidthInches.standardWaterproof
        : controls.rawWidthInches.standardNoSeeUm);
    const closure = widthClass === 'wide'
      ? controls.closures.wide.total
      : controls.closures.standard.total;
    const body = rawLength * rawWidth / 1296 * fabric.density;
    const vent = fabric.waterproof && vented
      ? rawLength * controls.vent.widthInches / 1296 * data.shared.netting.noSeeUm09.planningDensity
      : 0;
    const pocket = POCKET[pocketChoice]
      ? data.shared.components.zipperedStrapPocket
      : 0;
    const finished = body + vent + closure + pocket + controls.constructionAllowance;

    return { body, vent, closure, pocket, rawLength, rawWidth, finished };
  }

  function start() {
    const root = document.querySelector('[data-sld-catch-all-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const result = estimate(selections(scope));
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');

      if (!result || result.incompatible) {
        if (results) results.hidden = true;
        if (message) {
          message.textContent = result && result.incompatible
            ? result.message
            : 'Select your fabric, hammock length, and width to see the estimated weight.';
        }
        return;
      }

      const weight = root.querySelector('[data-sld-weight-catch-all]');
      if (weight) weight.textContent = result.finished.toFixed(1) + ' oz';
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return { estimate, selections, start };
});
